import React from 'react';
import CabecalhoGrafico from 'components/Windx/CabecalhoGrafico';
import GraficoSM from 'components/Windx/GraficoSM';
import useIsMobile from 'utils/hooks/useIsMobile';

import SemanalMobile from './Mobile';

export default function WindxSemanal() {
  const isMobile = useIsMobile();

  if (isMobile) return <SemanalMobile />;

  // WINDX-038 Frente B: wrapper flex container — ver SemiHorario/index.tsx
  return (
    <div className="p-4 d-flex flex-column flex-grow-1" style={{ minHeight: 0 }}>
      <CabecalhoGrafico tela="sm">
        <GraficoSM />
      </CabecalhoGrafico>
    </div>
  );
}
